export default "__VITE_ASSET__Cju$mti8__"